// Give same-origin story navigation a shared visual thread in supporting browsers.
(function () {
    var storySelector = [
        '.edition-lead',
        '.edition-card',
        '.edition-pick',
        '.edition-latest-item',
        '.edition-topic-lead',
        '.edition-topic-item',
        '.post-card'
    ].join(', ');
    var sourceClass = 'is-story-transition-source';
    var storageKey = 'northline-story-transition-path';
    var pendingKey = 'northline-navigation-pending';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var supportsCrossDocument = 'onpageswap' in window && 'onpagereveal' in window;

    function cleanSources() {
        document.querySelectorAll('.' + sourceClass).forEach(function (element) {
            element.classList.remove(sourceClass);
        });
    }

    function storyPath(link) {
        try {
            var url = new URL(link.href, window.location.href);

            return url.origin === window.location.origin ? url.pathname : null;
        } catch (error) {
            return null;
        }
    }

    function rememberPath(path) {
        try {
            sessionStorage.setItem(storageKey, path);
        } catch (error) {
            // Storage can be unavailable in hardened/private contexts.
        }
    }

    function markNavigationPending() {
        try {
            sessionStorage.setItem(pendingKey, 'true');
        } catch (error) {
            // Regular navigation remains the complete fallback.
        }
    }

    function decorateStory(story, path) {
        if (!story) {
            return;
        }

        cleanSources();
        story.classList.add(sourceClass);

        if (path) {
            rememberPath(path);
        }
    }

    function findStory(path) {
        var matchingLink = Array.from(document.querySelectorAll(storySelector + ' a[href]')).find(function (link) {
            return storyPath(link) === path;
        });

        return matchingLink && matchingLink.closest(storySelector);
    }

    document.addEventListener('click', function (event) {
        var link = event.target.closest('a[href]');

        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target || link.hasAttribute('download')) {
            return;
        }

        var story = link.closest(storySelector);
        var path = story && storyPath(link);

        if (story && path) {
            decorateStory(story, path);

            if (!supportsCrossDocument && !reduceMotion) {
                event.preventDefault();
                markNavigationPending();
                document.documentElement.classList.add('is-navigation-leaving');

                window.setTimeout(function () {
                    window.location.assign(link.href);
                }, 180);
            }
        }
    }, true);

    if (document.documentElement.classList.contains('has-navigation-entry')) {
        try {
            sessionStorage.removeItem(pendingKey);
        } catch (error) {
            // The animation class is also removed after it completes.
        }

        var content = document.querySelector('.site-content');

        if (content) {
            content.addEventListener('animationend', function () {
                document.documentElement.classList.remove('has-navigation-entry');
            }, {once: true});
        }
    }

    if (!supportsCrossDocument) {
        return;
    }

    window.addEventListener('pagereveal', function (event) {
        if (!event.viewTransition) {
            cleanSources();
            return;
        }

        var path = null;

        try {
            if (window.navigation && navigation.activation && navigation.activation.from) {
                path = new URL(navigation.activation.from.url).pathname;
            }

            path = path || sessionStorage.getItem(storageKey);
        } catch (error) {
            // The root transition remains a complete fallback.
        }

        decorateStory(findStory(path), path);
        event.viewTransition.finished.then(cleanSources, cleanSources);
    });
})();
